module.exports = __webpack_public_path__ + "img/Arrow.8adc1e0d.svg";